// Partner voices — anonymized roles + institution types.
// Replace with real attributions once legal/PR sign-off is in place.
// Language: never "customer" — always partner / strategic collaboration / partnership.

export type PartnerVoice = {
  quote: string;
  role: string;
  org: string;
};

export const partnerVoices: PartnerVoice[] = [
  {
    quote:
      "Without the right infrastructure underneath the AI strategy, even strong models do not deliver real value. deepc is that infrastructure.",
    role: "Head of AI Innovation",
    org: "NHS TRUST",
  },
  {
    quote:
      "Infrastructure changes where the governance burden sits - away from individual clinicians and into a standardized deployment model.",
    role: "Clinical Oncology Lead",
    org: "REGIONAL HEALTH AUTHORITY",
  },
  {
    quote:
      "Technology investment has to connect to operational value. We needed AI to reduce burden on clinical teams and integrate cleanly with existing systems.",
    role: "Chief Medical Information Officer",
    org: "University Hospital",
  },
  {
    quote:
      "The point solutions weren't a vendor problem, they were a governance problem. Each comes with its own integration assumptions and compliance requirements at compounding costs. At some point that stops being manageable.",
    role: "Chief Digital Officer",
    org: "HEALTH SYSTEM",
  },
  {
    quote:
      "The goal was never to deploy AI at the level of one condition or one department. We needed something the whole patient pathway could run on, across sites, across teams.",
    role: "Director of Imaging Informatics",
    org: "ACADEMIC MEDICAL CENTER",
  },
  {
    quote:
      "Every stage has its own overhead. It starts the moment you try to access data for validation. We knew how to build models that worked. What the right infrastructure gave us was a repeatable path to get them into clinical use.",
    role: "Medical AI Research Lead",
    org: "RESEARCH HOSPITAL",
  },
  {
    quote:
      "The volume we deal with means there's no tolerance for workflow friction. What AI gave us wasn't speed for its own sake. It was confidence at scale, without adding steps for the radiologist.",
    role: "Head of Emergency Radiology",
    org: "TRAUMA CENTER",
  },
  {
    quote:
      "We'd validated models on research data. Moving them into clinical environments meant rebuilding trust with clinicians, IT, and information governance every time. Having a partner with the right infrastructure changed that dynamic.",
    role: "Director of Clinical Informatics",
    org: "Teaching Hospital",
  },
  {
    quote:
      "Every AI solution that arrives through a department without central oversight adds to the integration debt. We needed clinical teams to have access to what they needed, while keeping the technology environment governable.",
    role: "Chief Information Officer",
    org: "NATIONAL HEALTH SYSTEM",
  },
];
